import React, { useState, useEffect, useRef } from "react";
import Star from "./vectors/Star";
import Snowflake from "./vectors/Snowflake";
import "./Themes.scss";
import VectorGround from "./vectors/VectorGround";
import VectorMountainsFar from "./vectors/VectorMountainsFar";
import VectorTree from "./vectors/VectorTree";
import VectorHouse from "./vectors/VectorHouse";
import VectorMoon from "./vectors/VectorMoon";

const MAX_STARS = 30;
const MAX_SNOWFLAKES = 12;

interface StarConfig {
    id: number;
    left: number;
    top: number;
    delay: number;
}

interface SnowflakeConfig {
    id: number;
    left: number;
    delay: number;
}

const ThemeXmas = ({ children }: { children?: React.ReactNode }) => {
    const [stars, setStars] = useState<StarConfig[]>([]);
    const [snowflakes, setSnowflakes] = useState<SnowflakeConfig[]>([]);
    const snowflakeIntervalRef = useRef<NodeJS.Timeout | null>(null);

    // Create snowflake
    const createSnowflake = () => {
        setSnowflakes((prev) => {
            if (prev.length >= MAX_SNOWFLAKES) return prev;

            const newSnowflake = {
                id: Date.now() + Math.random(),
                left: Math.random() * 100,
                delay: Math.random() * 0.1,
            };

            // Remove after animation
            setTimeout(() => {
                setSnowflakes((current) =>
                    current.filter((s) => s.id !== newSnowflake.id)
                );
            }, 8000);

            return [...prev, newSnowflake];
        });
    };

    useEffect(() => {
        // Create initial stars
        const initialStars: StarConfig[] = [];
        for (let i = 0; i < MAX_STARS; i++) {
            initialStars.push({
                id: Date.now() + Math.random() + i,
                left: Math.random() * 100,
                top: Math.random() * 100,
                delay: Math.random() * 2,
            });
        }
        setStars(initialStars);

        // Create snowflakes continuously
        snowflakeIntervalRef.current = setInterval(() => {
            createSnowflake();
        }, 200);

        return () => {
            if (snowflakeIntervalRef.current) {
                clearInterval(snowflakeIntervalRef.current);
            }
        };
    }, []);


    return (
        <div className="is-theme-xmas">
            {children}
            <div className="nav-body-vectors">
                {/* Stars */}
                {stars.map((star) => (
                    <Star
                        key={star.id}
                        left={star.left}
                        top={star.top}
                        delay={star.delay}
                    />
                ))}

                {/* Mountains far (đậm hơn, nhô cao) - z-index 0 */}
                <VectorMountainsFar className="vector-mountains-far" />

                {/* Ground (mặt đất mượt) - z-index 1 */}
                <VectorGround className="vector-ground" />

                {/* Trees x3*/}
                <VectorTree className="vector-tree tree-1" />
                <VectorTree className="vector-tree tree-2" />
                <VectorTree className="vector-tree tree-3" />

                {/* Houses x2*/}
                <VectorHouse className="vector-house house-1" />
                <VectorHouse className="vector-house house-2" />

                {/* Moon */}
                <VectorMoon className="vector-moon" />

                {/* Snowflakes */}
                {snowflakes.map((snowflake) => (
                    <Snowflake
                        key={snowflake.id}
                        left={snowflake.left}
                        delay={snowflake.delay}
                    />
                ))}
            </div>
        </div>
    );
};

export default ThemeXmas;
